import { view } from '@yola/ws-sdk';

const setLiveMapSource = (elementId, src) => {
  view.operations.setElementAttribute(elementId, 'src', src);
};

export default setLiveMapSource;
